export default __webpack_public_path__ + "static/media/img/dp4.webp";